import { featuredComics } from '@/mocks/home';

export default function FeaturedSection() {
  return (
    <section id="featured" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-10">
        <div className="text-center mb-12 md:mb-14">
          <span className="font-heading text-xs md:text-sm tracking-[0.3em] uppercase text-foreground-500">
            WAIWAI COMICS
          </span>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-black text-foreground-950 mt-3 tracking-tight">
            精选专区
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          {featuredComics.map((item, index) => {
            if (item.bgStyle === 'dark') {
              return (
                <div
                  key={item.id}
                  className="relative rounded-2xl bg-primary-500 p-6 md:p-8 flex flex-col justify-between min-h-[320px] md:min-h-[380px] overflow-hidden group cursor-pointer"
                >
                  <div className="absolute top-0 right-0 w-32 h-32 bg-accent-500/20 rounded-bl-full"></div>
                  <div className="relative z-10">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-400/50 mb-5 md:mb-6">
                      <i className={`${item.icon} text-xl md:text-2xl text-background-50`}></i>
                    </div>
                    <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">
                      {item.title}
                    </h3>
                    <p className="text-sm text-background-50/60 leading-relaxed">
                      {item.subtitle}
                    </p>
                  </div>
                  <div className="relative z-10 mt-6">
                    <span className="inline-flex items-center gap-1 text-sm text-accent-300 group-hover:text-accent-200 transition-colors duration-200">
                      立即探索 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              );
            }

            if (item.bgStyle === 'image') {
              return (
                <div
                  key={item.id}
                  className="relative rounded-2xl overflow-hidden min-h-[320px] md:min-h-[380px] group cursor-pointer"
                >
                  <img
                    src={item.coverImage}
                    alt={item.title}
                    className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`歪歪漫画 - ${item.title}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-950/60 text-background-50 text-xs font-medium backdrop-blur-sm">
                      <i className="ri-fire-line text-sm"></i>
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">
                      {item.title}
                    </h3>
                    <p className="text-sm text-background-50/70 mt-1.5">
                      {item.subtitle}
                    </p>
                  </div>
                </div>
              );
            }

            return (
              <div
                key={item.id}
                className="relative rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden min-h-[320px] md:min-h-[380px] group cursor-pointer"
              >
                <div className="p-6 md:p-8 flex flex-col h-full">
                  <div className="flex-1">
                    <h3 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-3">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                      {item.subtitle}
                    </p>
                  </div>
                  <div className="relative rounded-xl overflow-hidden h-40 md:h-48">
                    <img
                      src={item.coverImage}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`歪歪漫画 - ${item.title}`}
                    />
                    <div className="absolute inset-0 bg-primary-500/10"></div>
                  </div>
                  <div className="mt-4">
                    <span className="inline-flex items-center gap-1 text-sm text-accent-500 font-medium group-hover:text-accent-600 transition-colors duration-200">
                      了解更多 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}